import { Typography } from '@mui/material'
import { GridGroupNode, GridRowId, useGridApiContext } from '@mui/x-data-grid-premium'
import { useTranslation } from 'react-i18next'

// A server data source that caps a group's loaded children (see useRequestsDataSource / useBillsDataSource)
// leaves the group's true size on the row while fewer children are actually loaded — surface the difference.
export const GroupChildrenTruncationLabel = ({ id }: { id: GridRowId }) => {
  const { t } = useTranslation('common')
  const apiRef = useGridApiContext()

  const totalChildCount = apiRef.current?.getRow(id)?.childCount
  const loadedChildCount = apiRef.current?.getRowNode<GridGroupNode>(id)?.children?.length
  const isTruncated =
    typeof totalChildCount === 'number' &&
    loadedChildCount !== undefined &&
    loadedChildCount > 0 &&
    loadedChildCount < totalChildCount

  if (!isTruncated) return null

  return (
    <Typography variant="body-regular" color="text.muted">
      {t('row-grouping.showing-first-of', { shown: loadedChildCount, total: totalChildCount })}
    </Typography>
  )
}
